import { QueryFunctionContext } from '@tanstack/react-query';
import { QueryKey } from '@/configs/queryKeys';
import { Attachment, Translations, UUID } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export type GrekonContentBlockType = 'text' | 'wysiwyg';

export interface GrekonContentBlock {
	id: string;
	section: string;
	type: GrekonContentBlockType;
	value: string;
	createdAt?: string;
	updatedAt?: string;
}

export enum ContentType {
	TEXT = 'text',
	IMAGE = 'image',
	ELEMENT = 'element',
}

export interface Content extends BaseEntity {
	slug: string;
	type: ContentType;
	content: string;
	image: Pick<Attachment, 'id' | 'path'> | null;
	translations: Translations<{
		content: string;
		image: Pick<Attachment, 'id' | 'path'> | null;
	}> | null;
}

const mapType = (type: GrekonContentBlockType): ContentType =>
	type === 'wysiwyg' ? ContentType.ELEMENT : ContentType.TEXT;

class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.content);
	}

	override async getAll({ queryKey }: QueryFunctionContext<[QueryKey]>) {
		const response = await httpClient.get<GrekonContentBlock[]>(queryKey[0]);
		return response.data.map<Content>((block) => ({
			id: block.id as UUID,
			slug: block.section,
			type: mapType(block.type),
			content: block.value ?? '',
			image: null,
			translations: null,
			createdAt: block.createdAt ?? '',
			updatedAt: block.updatedAt ?? '',
		}));
	}
}

export default new ContentApi();
